import { Link } from "react-router-dom";
import { features } from "@/mocks/homeData";

const featureImages: Record<string, string> = {
  "feat-automation": "https://readdy.ai/api/search-image?query=Close-up%20of%20mechanical%20clockwork%20gears%20in%20warm%20brass%20tones%20with%20soft%20bokeh%20background%2C%20symbolizing%20automation%20and%20precision%2C%20artistic%20macro%20photography%2C%20golden%20cream%20and%20bronze%20palette%2C%20elegant%20industrial%20aesthetic&width=600&height=800&seq=feat-automation-v3e&orientation=portrait",
  "feat-analysis": "https://readdy.ai/api/search-image?query=Stacked%20vintage%20books%20with%20colorful%20tabs%20and%20markers%20on%20wooden%20desk%2C%20warm%20library%20light%2C%20scholarly%20analytical%20atmosphere%2C%20cream%20and%20mahogany%20tones%2C%20intellectual%20editorial%20style%2C%20soft%20depth%20of%20field&width=600&height=800&seq=feat-analysis-v3e&orientation=portrait",
  "feat-scalability": "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20terraced%20rice%20fields%20ascending%20a%20gentle%20hillside%2C%20layered%20organic%20patterns%2C%20warm%20morning%20mist%2C%20symbolizing%20growth%20and%20scalability%2C%20earthy%20green%20and%20gold%20palette%2C%20peaceful%20natural%20landscape&width=600&height=800&seq=feat-scalability-v3e&orientation=portrait",
};

export default function FeatureGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-16 bg-background-50">
      <div className="mb-10 md:mb-14">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl">
          Pourquoi choisir <span className="italic">Hipobuy Spreadsheet</span> ?
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 leading-relaxed max-w-xl">
          ✔ Remplace Excel manuel &nbsp;·&nbsp; ✔ Automatise le suivi produit &nbsp;·&nbsp; ✔ Améliore les marges e-commerce &nbsp;·&nbsp; ✔ Compatible dropshipping, Shopify et Amazon &nbsp;·&nbsp; ✔ Analyse de données simplifiée
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {features.map((feat, idx) => (
          <div
            key={feat.id}
            className={`group relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
              idx === 0 ? "md:col-span-1" : ""
            }`}
          >
            <div className="aspect-[3/4] relative overflow-hidden">
              <img
                src={featureImages[feat.imageSeq]}
                alt={feat.title}
                title={feat.title}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-background-50 mb-2">
                  {feat.title}
                </h3>
                <p className="text-sm text-background-200 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 max-w-xs">
                  {feat.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to="/guide-hipobuy-spreadsheet"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors underline underline-offset-4 whitespace-nowrap"
        >
          En savoir plus sur hipobuy spreadsheet
          <i className="ri-arrow-right-line text-xs"></i>
        </Link>
      </div>
    </section>
  );
}